import { useFontRender } from "@/components/FontRender";
import { useComponent } from "@/hooks/useMicrositeComponent";
import { IMicrositeComponent, MComponentCountdown } from "@/types/microsite";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useEffect, useMemo, useState } from "react";

dayjs.extend(duration);

const CountdownComponent = {
  kind: "COUNTDOWN",
  Render: ({ isBuilder, id, data: { textFont, timestamp } }) => {
    const { focusTo } = useComponent();
    const fontSize = useMemo(() => {
      if (preferedFontSize[textFont]) {
        return preferedFontSize[textFont];
      }
      return "2em";
    }, [textFont]);

    const { fontStyle, RenderFontStyle } = useFontRender({
      textFont,
      style: { fontSize },
    });

    const [countdown, setCountdown] = useState({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    useEffect(() => {
      let tick: any = null;
      const countTick = () => {
        if (timestamp > -1) {
          const curr = dayjs();
          const diff = dayjs.unix(timestamp).diff(curr);
          const day = dayjs.unix(timestamp).diff(curr, "day");
          if (diff < -1) {
            clearInterval(tick);
            setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            return;
          }
          const dur = dayjs.duration(diff);
          const output = {
            days: day,
            hours: dur.hours(),
            minutes: dur.minutes(),
            seconds: dur.seconds(),
          };
          setCountdown(output);
        } else {
          clearInterval(tick);
        }
      };

      countTick();

      tick = setInterval(countTick, 1000);

      return () => {
        clearInterval(tick);
      };
    }, [timestamp]);

    const formatNumber = (num: number) => {
      return num.toString().padStart(2, "0");
    };

    return (
      <div
        className="p-2 w-full"
        id={isBuilder ? `mcomp-${id}` : undefined}
        onClick={() => {
          if (isBuilder && id) focusTo(id);
        }}
      >
        {RenderFontStyle}
        <div className="flex justify-center mb-3" style={fontStyle}>
          <div>
            <DurInt>{formatNumber(countdown.days)}</DurInt>
            <DurLabel>Days</DurLabel>
          </div>
          <div>
            <DurInt>:</DurInt>
            <DurLabel></DurLabel>
          </div>
          <div>
            <DurInt>{formatNumber(countdown.hours)}</DurInt>
            <DurLabel>Hours</DurLabel>
          </div>
          <div>
            <DurInt>:</DurInt>
            <DurLabel></DurLabel>
          </div>
          <div>
            <DurInt>{formatNumber(countdown.minutes)}</DurInt>
            <DurLabel>Minutes</DurLabel>
          </div>
          <div>
            <DurInt>:</DurInt>
            <DurLabel></DurLabel>
          </div>
          <div>
            <DurInt>{formatNumber(countdown.seconds)}</DurInt>
            <DurLabel>Seconds</DurLabel>
          </div>
        </div>
      </div>
    );
  },
} as IMicrositeComponent<MComponentCountdown>;

const DurInt = (props) => {
  return <div {...props} className="px-1.5 text-center" />;
};
const DurLabel = (props) => {
  return (
    <div {...props} style={{ fontSize: "0.5em" }} className="text-center" />
  );
};

const preferedFontSize = {
  "bebas-neue": "3rem",
  licorice: "3rem",
  lobster: "2.5rem",
  "indie-flower": "3em",
  caveat: "3em",
};

export default CountdownComponent;
